export default "__VITE_ASSET__BLDMJUtZ__"